import {
  Component, EventEmitter, Input, NgModule, Output, ViewChild,
} from '@angular/core';
import {
  DxCalendarModule,
  DxDropDownButtonModule,
  DxDropDownButtonComponent,
  DxDateBoxModule,
} from 'devextreme-angular';

import { DxCalendarTypes } from 'devextreme-angular/ui/calendar';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'form-item-date',
  template: `
    <dx-date-box
      stylingMode="filled"
      placeholder="éééé-hh-nn"
      displayFormat="yyyy-MM-dd"
      pickerType="calendar"
      [readOnly]="!isEditing"
      [label]="label"
      [elementAttr]="{class: 'form-editor'}"
      [inputAttr]="{class: 'form-editor-input'}"
      (onValueChanged)="valueChanged($event)"
      [(value)]="value"
  ></dx-date-box>`,
})
export class FormDateboxComponent {
  @ViewChild(DxDropDownButtonComponent) dropDownButtonComponent: DxDropDownButtonComponent;

  @Input() isEditing = false;

  @Input() label = '';

  @Input() value!: string | Date | number;

  @Output() valueChange: EventEmitter<string | Date | number> = new EventEmitter();

	valueChanged(e) {
    this.value = e.value;
		this.valueChange.emit(e.value);
    this.dropDownButtonComponent?.instance?.close();
	}  
}

@NgModule({
  imports: [
    DxCalendarModule,
    DxDropDownButtonModule,
    DxDateBoxModule,
    CommonModule,
  ],
  providers: [],
  exports: [FormDateboxComponent],
  declarations: [FormDateboxComponent],
})
export class FormItemDateModule { }
